import { RoleModel } from "./model"; // not in use

// import UsersJar from "./jar";

/* Services */
import RoleService from "./service";

/* Storage */
// import UsersStorage from "./storage";

/* Factories */
import RoleFactory from "./factory";

// /* Facades */
import Roles from "./facade";

const modul = angular
    .module("RoleModule", [])

    .constant("RoleModel", RoleModel)

    /**
     * BookingJar - Holds variables internally
     */
    // .service("RolesJar", BookingJar)

    /**
     * Services
     * * can only have utility dependencies
     */
    .factory("RoleService", RoleService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    // .factory("BasketStorage", BasketStorage)

    /**
     * Factories
     */
    .factory("RoleFactory", RoleFactory)

    /**
     * Facades
     */
    .factory("Roles", Roles);

export default modul.name;
